import { Image } from '@ahmdigital/ui';
import styled from 'styled-components';

import { ImageType } from '../../../../../types/image';

type IsTwoColumn = boolean | undefined;

const ImageWrapper = styled.div`
  text-align: center;

  ${({ isTwoColumn }: { isTwoColumn?: IsTwoColumn }) =>
    isTwoColumn &&
    `
      margin-bottom: 1rem;
  `}

  @media (min-width: ${({ theme }) => theme.media.md}) {
    margin-bottom: 0;
  }
`;

type AccordionImageProps = {
  image: ImageType | null | undefined;
  isTwoColumn?: IsTwoColumn;
};

const AccordionImage = ({ image, isTwoColumn }: AccordionImageProps) => {
  if (!image) return null;

  return (
    <ImageWrapper isTwoColumn={isTwoColumn}>
      <Image {...image} />
    </ImageWrapper>
  );
};

export default AccordionImage;
